module.exports = __webpack_public_path__ + "static/arrow_3_md-7f38665528fdad8ad5273f03dc49137a.png";